import { defineComponent as Y, ref as i, openBlock as T, createElementBlock as x, createElementVNode as l, normalizeStyle as r, withDirectives as c, createTextVNode as A, toDisplayString as f, withModifiers as $, vShow as a, renderSlot as I, createCommentVNode as M } from "vue";
import { guid as N } from "../utils/basic.js";
import "./AlertDialog.js";
import "./CommonDialog.css";
const V = { class: "modal-backdrop" }, X = ["id"], j = ["id"], F = /* @__PURE__ */ Y({
  __name: "CommonDialog",
  props: {
    title: { default: "" },
    options: { default: () => ({
      yesText: "",
      cancelText: "",
      buttonAlign: "",
      hideCancelBt: !1,
      hideYesBt: !1,
      hideCloseIcon: !1
    }) },
    bodyStyle: { default: "" },
    contentStyle: { default: "" }
  },
  emits: ["on-close", "on-cancel"],
  setup(g, { emit: k }) {
    var C, w;
    const o = g, m = k, v = i(""), u = i(""), p = i(), d = i(""), t = i({
      yesText: "OK",
      cancelText: "Cancel",
      showOk: !0,
      showCancel: !0,
      showClose: !0
    }), y = N();
    v.value = "dialog" + y, u.value = "head" + y, o.options && (o.options.yesText && (t.value.yesText = o.options.yesText), o.options.cancelText && (t.value.cancelText = o.options.cancelText), o.options.hideCancelBt && (t.value.showCancel = !1), o.options.hideYesBt && (t.value.showOk = !1), o.options.hideCloseIcon && (t.value.showClose = !1), ((C = o.options) == null ? void 0 : C.buttonAlign) === "center" ? d.value = "justify-content:center;" : ((w = o.options) == null ? void 0 : w.buttonAlign) === "left" && (d.value = "justify-content:flex-start;"));
    const S = () => {
      m("on-close");
    }, h = () => {
      m("on-cancel");
    }, B = (n) => {
      const e = p.value, s = document.getElementById(u.value);
      s.style.cursor = "move";
      const O = n.clientX - e.offsetLeft, D = n.clientY - e.offsetTop;
      document.onmousemove = function(E) {
        const b = E || n;
        e.style.left = b.clientX - O + "px", e.style.top = b.clientY - D + "px";
      }, document.onmouseup = function() {
        document.onmousemove = null, document.onmouseup = null, s.style.cursor = "default";
      };
    };
    return (n, e) => (T(), x("div", V, [
      l("div", {
        class: "modal-content",
        id: v.value,
        ref_key: "selectElement",
        ref: p,
        style: r(n.contentStyle)
      }, [
        c(l("div", {
          class: "modal-header",
          id: u.value,
          onMousedown: B
        }, [
          A(f(n.title) + " ", 1),
          c(l("a", {
            title: "close",
            class: "btn-close",
            onClick: e[0] || (e[0] = (s) => h()),
            onMousedown: e[1] || (e[1] = $(() => {
            }, ["stop"]))
          }, "×", 544), [
            [a, t.value.showClose]
          ])
        ], 40, j), [
          [a, n.title]
        ]),
        l("div", {
          class: "modal-body",
          style: r(n.bodyStyle)
        }, [
          I(n.$slots, "default", {}, void 0, !0)
        ], 4),
        t.value.showOk || t.value.showCancel ? (T(), x("div", {
          key: 0,
          class: "modal-footer",
          style: r(d.value)
        }, [
          c(l("button", {
            type: "button",
            class: "btn-confirm",
            onClick: e[2] || (e[2] = (s) => S())
          }, f(t.value.yesText), 513), [
            [a, t.value.showOk]
          ]),
          c(l("button", {
            type: "button",
            class: "btn-cancel",
            onClick: e[3] || (e[3] = (s) => h())
          }, f(t.value.cancelText), 513), [
            [a, t.value.showCancel]
          ])
        ], 4)) : M("", !0)
      ], 12, X)
    ]));
  }
});
export {
  F as default
};
